export * from './FlagAIcon';
export * from './FlagAIcon16Light';
export * from './FlagAIcon16Regular';
export * from './FlagAIcon16Solid';
export * from './FlagAIcon20Light';
export * from './FlagAIcon20Regular';
export * from './FlagAIcon20Solid';
export * from './FlagAIcon24Regular';
export * from './FlagAIcon24Solid';
export * from './FlagAIcon32Regular';
export * from './FlagAIcon64Regular';
